import { setPremiumTemporarilyEnabled } from '../actions/trialActions';
import getStore from '../store/store';
import { mutator } from 'satcheljs';

export const setPremiumTemporarilyEnabledMutator = mutator(
    setPremiumTemporarilyEnabled,
    actionMessage => {
        const store = getStore();
        store.premiumTemporarilyEnabled = actionMessage.enabled;
    }
);
